import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import { IProps } from './SelectAlbumPopup.types';

export const openSelectAlbumPopup = ({ onSuccess, onClose, onCreateAlbum, items }) => openPopupHelper<IProps>({ popupName: popupNames.SELECT_ALBUM, data: { onSuccess, onClose, items, onCreateAlbum } });
